var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[(_vm.hasName)?_c('div',{class:['dot', { 'dot-success': this.success }]},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e(),_c('div',{staticClass:"title mb-0"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }